const NotFound = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
            <div className="text-center">
                <h1 className="text-6xl font-bold text-red-600 mb-4">404</h1>
                <h2 className="text-2xl md:text-3xl font-semibold mb-2 text-gray-800">
                    Page Not Found
                </h2>
                <p className="text-gray-600 mb-6">
                    Sorry, the page you are looking for doesn’t exist or has
                    been moved.
                </p>
                <a
                    href="/"
                    className="inline-block px-4 py-2 text-sm bg-orange-500 text-white font-medium rounded hover:bg-orange-600 transition"
                >
                    Go Back Home
                </a>
            </div>
        </div>
    );
};

export default NotFound;
